import type { ReactNode } from "react";
import { Alert, Dialog, Button, Row } from "@narmi/design_system";

const ConfirmationDialog = ({
  isOpen,
  onConfirm,
  onUserDismiss,
  title,
  message,
  confirmText,
  cancelText,
  confirmDisabled,
  cancelDisabled,
  alertText,
}: {
  isOpen: boolean;
  onConfirm: () => void;
  onUserDismiss: () => void;
  title: string;
  message: ReactNode;
  confirmText?: string;
  cancelText?: string;
  confirmDisabled?: boolean;
  cancelDisabled?: boolean;
  alertText?: string;
}) => {
  return (
    <Dialog isOpen={isOpen} onUserDismiss={onUserDismiss} title={title}>
      <div className="padding--top--s">
        <div className="margin--bottom--s">
          <Alert isActive={!!alertText} isDismissable={false}>
            {alertText}
          </Alert>
        </div>

        <div className="margin--bottom--s">{message}</div>
        <div className="padding--top--s padding--bottom--s">
          <Row justifyContent="end" alignItems="center">
            <Row.Item shrink>
              <Button
                label={cancelText ? cancelText : "Cancel"}
                kind="plain"
                onClick={onUserDismiss}
                disabled={cancelDisabled}
              />
            </Row.Item>
            <Row.Item shrink>
              <Button
                label={confirmText ? confirmText : "Submit"}
                onClick={onConfirm}
                disabled={confirmDisabled}
              />
            </Row.Item>
          </Row>
        </div>
      </div>
    </Dialog>
  );
};

export default ConfirmationDialog;
